import classes from "../../purchase.module.scss";
import { dateToLocale, formatMiles, formatMilesDecimal } from "@/services/Utils";

const OrdersReturnTableBodyDetail = ({ item }) => {
	if (!item.active) {
		return null;
	}

	return (
		<tr className={classes.table_detail}>
			<td colSpan={12} className={classes.td_table}>
				<table className={classes.table_item}>
					<thead>
						<tr className={classes.table_item_tr}>
							<th className={classes.th_detail} style={{ width: "20%" }}>
								Producto
							</th>
							<th className={classes.th_detail} style={{ width: "15%" }}>
								Cant. Envases
							</th>
							<th className={classes.th_detail} style={{ width: "15%" }}>
								Contenido
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								U.M
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Precio
							</th>
							<th className={classes.th_detail} style={{ width: "15%" }}>
								Fecha de Vencimiento
							</th>
						</tr>
					</thead>

					<tbody>
						{item &&
							item.details.map((product, i) => {
								return (
									<tr key={i} className={`${classes.table_item_tr}`}>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${classes.first_div}`}>{product.tradename}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{formatMiles(product.quantity_return)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{formatMilesDecimal(product.container_content)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{product.unit_measurement}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>${formatMilesDecimal(product.price * product.quantity_return)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${classes.last_div}`}>
												{product.expiration_date ? dateToLocale(product.expiration_date) : ""}
											</div>
										</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

export default OrdersReturnTableBodyDetail;
